export const profileData = {
  name: "swas3301",
  tagline: "Building secure systems. Breaking assumptions.",
  bio: [
    "Working on crypto-integrated projects \u2014 from e-commerce platforms to full-scale Web3 applications.",
    "Currently deep-diving into cryptography, blockchain internals, and data structures & algorithms.",
    "Open to Web3, DeFi, and backend collaborations."
  ],
  topics: ["DSA", "Smart Contracts", "System Design"],
  funFact: "Enjoys optimizing algorithms & ethically breaking blockchains",
  image: "/pfp.jpeg",
  roles: [
    "Web3 Developer",
    "Cryptographer",
    "Backend Engineer",
    "Security Researcher",
    "DeFi Builder"
  ],
};

export const skillsData = {
  categories: [
    { name: "Languages", items: ["C", "C++", "Java", "HTML5", "JavaScript", "Bash", "Python", "PHP", "Rust", "TypeScript", "Go"] },
    { name: "Cloud & Infra", items: ["GCP", "AWS", "Azure", "Heroku", "Cloudflare", "Netlify"] },
    { name: "Frameworks", items: ["FastAPI", "Django", "Flask", "Next.js", "Node.js", "Vite", "Bootstrap"] },
    { name: "Databases", items: ["MongoDB", "MySQL", "SQLite", "PostgreSQL"] },
    { name: "DevOps & Security", items: ["Docker", "Apache", "Nginx", "TOR"] },
    { name: "ML & Testing", items: ["TensorFlow", "Playwright", "Selenium"] },
    { name: "Design", items: ["Figma", "Canva"] },
  ],
};

export const projectsData = [
  {
    id: 1,
    title: "E-Commerce with Crypto Payments",
    description: "Full-stack e-commerce platform with integrated cryptocurrency payment processing, real-time inventory management, and secure checkout flow.",
    tech: ["Python", "FastAPI", "React", "MongoDB", "Crypto"],
    category: "E-Commerce",
    status: "Active",
    hash: "0xa1b2...c3d4",
  },
  {
    id: 2,
    title: "Crypto Payment Gateway",
    description: "Litecoin payment gateway with xpub-based address generation, real-time transaction monitoring, and automated payment verification system.",
    tech: ["Python", "SQLAlchemy", "Litecoin", "WebSocket"],
    category: "Payment",
    status: "Active",
    hash: "0xe5f6...g7h8",
  },
  {
    id: 3,
    title: "CryptoVault DeFi",
    description: "Decentralized finance protocol with yield farming, staking, and cross-chain bridge capabilities built on Ethereum L2.",
    tech: ["Rust", "Solidity", "React", "Web3.js"],
    category: "DeFi",
    status: "Active",
    hash: "0x7f3a...b2c1",
  },
  {
    id: 4,
    title: "ZK-Auth Protocol",
    description: "Zero-knowledge authentication system for privacy-preserving identity verification on-chain.",
    tech: ["TypeScript", "Circom", "Next.js", "Ethereum"],
    category: "Cryptography",
    status: "In Development",
    hash: "0x9e1d...f4a8",
  },
  {
    id: 5,
    title: "BlockCommerce",
    description: "E-commerce platform with integrated cryptocurrency payments and NFT-based loyalty rewards program.",
    tech: ["Python", "FastAPI", "React", "Solana"],
    category: "Web3",
    status: "Active",
    hash: "0x2b5c...8d3e",
  },
  {
    id: 6,
    title: "NetSentinel",
    description: "Network security monitoring tool with real-time threat detection and blockchain-based audit logging.",
    tech: ["Go", "Docker", "PostgreSQL", "React"],
    category: "Security",
    status: "Completed",
    hash: "0x6a4f...1c7b",
  },
];

export const socialLinks = [
  { name: "Discord", url: "#" },
  { name: "LinkedIn", url: "#" },
  { name: "X", url: "#" },
  { name: "YouTube", url: "#" },
  { name: "Instagram", url: "#" },
  { name: "Reddit", url: "#" },
  { name: "Facebook", url: "#" },
];

export const marqueeWords = [
  "Web3", "Cryptography", "DeFi", "DSA", "Backend", "Security",
  "Blockchain", "Smart Contracts", "Zero Knowledge", "Rust",
  "System Design", "DevOps", "Ethical Hacking", "TypeScript",
  "Go", "Python", "Docker", "Solidity",
];
